import { useEffect } from 'react';
import { getSiteUrl } from '../utils/siteUrl';

type Props = {
  title: string;
  canonicalPath: string;
  description?: string;
};

function setMetaName(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setMetaProperty(property: string, content: string) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * Updates document title, canonical URL, core description, and Open Graph tags per route (SPA).
 */
export function RouteSeo({ title, canonicalPath, description }: Props) {
  useEffect(() => {
    const base = getSiteUrl();
    const path = canonicalPath.startsWith('/') ? canonicalPath : `/${canonicalPath}`;
    const canonicalUrl = path === '/' ? `${base}/` : `${base}${path}`;

    document.title = title;

    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = canonicalUrl;

    if (description) {
      setMetaName('description', description);
    }
    setMetaProperty('og:title', title);
    setMetaProperty('og:url', canonicalUrl);
    if (description) {
      setMetaProperty('og:description', description);
    }
    setMetaName('twitter:title', title);
    if (description) {
      setMetaName('twitter:description', description);
    }
  }, [title, canonicalPath, description]);

  return null;
}
